import {AxiosResponse} from "axios";
import Axios from "../config/Axios";

export const fetchVersion = async (): Promise<AxiosResponse> => {
    return await Axios.instance.get('public/version');
};


// WEBPACK FOOTER //
// ./app/actions/versionActions.ts